import React from 'react';
import styles from '../../../styles/usageRights.module.css';
import IconContainer from '../../common/IconContainer/IconContainer';

function UsageRightsFtux() {
  return (
    <div className={styles.usageRightFtuxContainer}>
      <IconContainer icon="🎥" />
      <div className={styles.usageRightFtuxTextContainer}>
        <div className={styles.usageRightFtuxTextTitle}>No Requests Available</div>
        <div className={styles.usageRightFtuxTextSubTitle}>
          When a brand requests for usage rights for your content, the requests will be available here.
        </div>
      </div>
    </div>
  );
}

export default UsageRightsFtux;
